import { EditorConfig, LexicalEditor, LexicalNode, SerializedTextNode, TextNode } from 'lexical';
import variables from 'styles/variables.scss';
import { DefaultCustomStyle } from 'const';
import { toPx } from 'utils/toPx';

const DEFAULT_FONT_COLOR = DefaultCustomStyle.FONT_COLOR;
const DEFAULT_FONT_SIZE = DefaultCustomStyle.FONT_SIZE;
const DEFAULT_FONT_FAMILY = variables.defaultFontFamily;

export class ColorlessTextNode extends TextNode {
  static getType(): string {
    return 'custom-colorless-text';
  }

  createDOM(config: EditorConfig, editor?: LexicalEditor): HTMLElement {
    const element = super.createDOM(config, editor);
    element.style.color = DEFAULT_FONT_COLOR;
    element.style.fontSize = toPx(DEFAULT_FONT_SIZE);
    element.style.fontFamily = DEFAULT_FONT_FAMILY;

    return element;
  }

  static clone(node: ColorlessTextNode): ColorlessTextNode {
    return new ColorlessTextNode(node.__text, node.__key);
  }

  exportJSON(): SerializedTextNode {
    return {
      ...super.exportJSON(),
      type: ColorlessTextNode.getType(),
    };
  }

  static importJSON(serializedNode: SerializedTextNode): ColorlessTextNode {
    return super.importJSON(serializedNode);
  }

}

export function $createColorlessTextNode(text: string): ColorlessTextNode {
  return new ColorlessTextNode(text);
}

export function $isColorlessTextNode(node: LexicalNode | null | undefined): node is ColorlessTextNode {
  return node instanceof ColorlessTextNode;
}
